import { useSettings } from "@/context/AppContext";

export const LogoMark = ({ className = "h-9 w-9" }) => <img src="/brand/logo-mark.png" alt="" className={`${className} object-contain`} />;

export const Logo = ({ light = false, className = "" }) => {
  const { settings } = useSettings() || {};
  const name = settings?.brand?.name || "Conexão Litigium";
  const logoUrl = settings?.brand?.logo_url;
  if (light && !logoUrl)
    return <img src="/brand/logo-wordmark.png" alt={name} className={`h-11 w-auto ${className}`} data-testid="brand-logo" />;
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      {logoUrl ? <img src={logoUrl} alt="" className="h-9 w-9 rounded-xl object-cover" /> : <LogoMark />}
      <span className={`font-display text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-[#092C66]"}`}>{name}</span>
    </span>
  );
};
